import { useEffect, useMemo, useState } from 'react';

import { ProductPickerItem } from '../PlanPurchaseFlow/PickProductStep/getPickerItems';
import { filterItemsByTab } from './ProductSlider.utils';
import { ProductTab } from './ProductTabs';

export interface UseProductPickerProps {
  items: ProductPickerItem[];
  availableTabs: ProductTab[];
}

export const useProductPicker = ({
  items,
  availableTabs,
}: UseProductPickerProps) => {
  // Set initial active tab to first available tab
  const [activeTab, setActiveTab] = useState<string>(
    availableTabs[0]?.id ?? ''
  );

  // Update active tab when available tabs change
  useEffect(() => {
    const tabIds = availableTabs.map((tab) => tab.id);

    if (availableTabs.length > 0 && !tabIds.includes(activeTab)) {
      setActiveTab(availableTabs[0].id);
    }
  }, [availableTabs, activeTab]);

  // Filter items by active tab
  const filteredItems = useMemo(() => {
    if (!items) {
      return [];
    }

    // If no tabs, return all items
    if (availableTabs.length === 0) {
      return items;
    }

    return filterItemsByTab([...items], activeTab);
  }, [items, activeTab, availableTabs.length]);

  return {
    availableTabs,
    activeTab,
    setActiveTab,
    filteredItems,
  };
};
